module.exports = __webpack_public_path__ + "img/Siper-Brosur-Small.e1598389.jpg";